var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "action-pane-wrapper h-100",
      attrs: { id: "follow-up-tab" },
    },
    [
      _c(
        "form",
        {
          staticClass: "h-100",
          attrs: { id: "referrer-follow-up-form" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.handleSubmit.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "form-group-material mb-0 form-group-wide no-validation-icons",
            },
            [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.description,
                    expression: "description",
                  },
                ],
                ref: "descriptionField",
                staticClass: "form-control required",
                attrs: {
                  id: "enter-description",
                  placeholder: _vm.$t("global.actions.enterDescription"),
                  type: "text",
                  name: "description",
                },
                domProps: { value: _vm.description },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.description = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "d-none", attrs: { for: "enter-description" } },
                [_vm._v(_vm._s(_vm.$t("global.actions.enterDescription")))]
              ),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "d-none", attrs: { for: "foreColorPicker" } },
                [_vm._v(_vm._s(_vm.$t("global.words.color")))]
              ),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "d-none", attrs: { for: "backColorPicker" } },
                [_vm._v(_vm._s(_vm.$t("global.words.color")))]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "align-items-center justify-content-end" },
            [
              _c(
                "b-col",
                { staticClass: "col-xl", attrs: { cols: "12" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        {
                          staticClass:
                            "col-xl-4 col-lg-6 col-sm-6 d-flex align-items-end",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "bold text-regular-gray tiny text-uppercase mr-3 align-self-center",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("global.words.when")) +
                                  "?\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "material-input",
                            {
                              staticClass: "mb-0",
                              attrs: {
                                value: _vm.scheduledDate,
                                "class-name": "required valid-date future-date",
                                name: "scheduledDate",
                                type: "text",
                                placeholder: "yyyy-mm-dd",
                              },
                            },
                            [
                              _c("datepicker-input", {
                                staticClass: "required valid-date future-date",
                                attrs: {
                                  id: "date-input",
                                  value: _vm.scheduledDate,
                                  name: "scheduledDate",
                                  placeholder: "yyyy-mm-dd",
                                  "future-date": "",
                                },
                                on: { change: _vm.handleScheduledDateChange },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass:
                            "col-xxl-4 col-xl-3 col-lg-6 col-sm-6 d-flex align-items-end",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "bold text-regular-gray tiny text-uppercase mr-3 align-self-center",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("global.words.at")) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "form-container form-group-material form-group-material-no-label position-relative fe-dp",
                            },
                            [
                              _c("time-input", {
                                attrs: {
                                  id: "time-input",
                                  "default-value": _vm.followUpNotificationTime,
                                  label: _vm.$t("global.words.time"),
                                  "hidden-label": "",
                                },
                                model: {
                                  value: _vm.scheduledTime,
                                  callback: function ($$v) {
                                    _vm.scheduledTime = $$v
                                  },
                                  expression: "scheduledTime",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass:
                    "col-xl-auto mt-xl-0 mt-4 pt-xl-0 pt-2 d-flex justify-content-end",
                  attrs: { cols: "12" },
                },
                [
                  _c(
                    "simple-button",
                    {
                      attrs: {
                        type: "primary",
                        "class-name":
                          "btn-sm submit-changes simple-button mt-3",
                        disabled: !_vm.canSave,
                        loading: _vm.loading,
                        "loading-succeeded": _vm.loadingSucceeded,
                      },
                      on: { click: _vm.handleSubmit },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.followUpId
                              ? _vm.$t("client-profile.actions.editActivity")
                              : _vm.$t("client-profile.actions.createActivity")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }